import { render, staticRenderFns } from "./MonthRegister.vue?vue&type=template&id=2cef0a28&scoped=true&"
import script from "./MonthRegister.vue?vue&type=script&lang=js&"
export * from "./MonthRegister.vue?vue&type=script&lang=js&"
import style0 from "./MonthRegister.vue?vue&type=style&index=0&id=2cef0a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cef0a28",
  null
  
)

export default component.exports